import ModalSelectPhotoComments from '@components/modal-select-photo-comments/modal-select-photo-comments.component'
import PhotoCommentsInstagram from '@components/photo-comments-instagram/photo-comments-instagram'
import { CommentsInstagram, Media } from '@hub/shared'
import { useState } from 'react'
import './selector-photo-comments.component.scoped.scss'

interface PhotoLegendProps extends React.HTMLAttributes<HTMLDivElement> {
  photo: Media
  onChangeSaveComments: (photo: Media, comments: Array<CommentsInstagram>) => void
  idProfile: string
  label?: any
  name: string
  comments?: Array<CommentsInstagram>
  minComments?: number
}

export default ({
  photo,
  onChangeSaveComments,
  idProfile,
  label = '',
  name = '',
  comments = [],
  minComments = 3,
  className = '',
}: PhotoLegendProps) => {
  const timestamp = `random-id-${(1 + Date.now() + Math.random()).toString().replace('.', '')}`
  const [openSelectPhoto, setOpenSelectPhoto] = useState(false)

  const handleChange = (newPhoto: Media, newComments: CommentsInstagram[] = []) => {
    setOpenSelectPhoto(false)
    if (onChangeSaveComments && typeof onChangeSaveComments === 'function') {
      onChangeSaveComments(newPhoto, newComments)
    }
  }

  const emptyPhoto = (
    <span className="empty-photo img-fluid">
      <i className="fa-regular fa-image"></i>
    </span>
  )

  return (
    <div>
      <div className={`selector-photo-comments ${className}`} role="button">
        <label className="label">{label}</label>
        <span className={`wrapper-photo ${photo ? 'has-photo' : ''}`} role="button" tabIndex={0} onClick={() => setOpenSelectPhoto(true)}>
          {photo ? <PhotoCommentsInstagram photo={photo} comments={comments} /> : emptyPhoto}
        </span>
      </div>
      <ModalSelectPhotoComments
        open={openSelectPhoto}
        onOpenChange={(open: boolean) => setOpenSelectPhoto(open)}
        onChangeSave={(newPhoto: Media, newComments: Array<CommentsInstagram>) => handleChange(newPhoto, newComments)}
        idProfile={idProfile}
        name={`${name || timestamp}-modal`}
        selectedPhoto={photo}
        comments={comments}
        minComments={minComments}
      />
    </div>
  )
}
